import { COLORS } from "../../../constants";

/**
 * Design tokens for the redesigned billing surfaces (Members page, seats dialog).
 *
 * Values come from the Coefficient design system export (colors_and_type.css) rather than the
 * legacy app palette: where a token has an exact match in `COLORS` we reference it, and the
 * rest are design-system colors that intentionally differ from the app's legacy palette (e.g.
 * the DS primary #2778F2 vs the app's coeblue4 #3053FF). Keep new billing UI on these tokens
 * instead of ad-hoc hex values.
 */
export const BILLING_TOKENS = {
  text: COLORS.black85, // #262626
  heading: "#292929",
  muted: COLORS.black65, // #595959
  placeholder: "#979797",
  faint: COLORS.black25, // #BFBFBF
  divider: "#EEEEEE",
  border: COLORS.black15, // #D9D9D9
  borderSubtle: COLORS.black9, // #E8E8E8
  surface: COLORS.white, // #FFFFFF
  sunken: COLORS.black4, // #F5F5F5
  rowHover: "#FAFBFD",
  rowSel: "#F5F9FF",
  blue: "#2778F2",
  blueHover: "#1E6AE0",
  blueDisabled: "#9BC0FA",
  blue50: "#ECF6FF",
  proBg: "#FFD84D",
  proFg: "#5C4600",
  starterBg: "#E8F7F7",
  starterFg: "#0A6E72",
  memberBg: "#F0F0F0",
  memberFg: COLORS.black65,
  pendingBg: "#FBF3E2",
  pendingFg: "#8A6400",
  warnBg: "#FBF3E2",
  warnFg: "#5C4600",
  danger: "#E5484D",
  dangerBg: "#FFF1F1",
} as const;
